import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button';
import I18n from '../i18n';
import HelpContext from '../../contexts/help-context';
import config from '../../config';

const WINDOW_TARGET = 'vhthelp';

export default function HelpButton(props) {
  const {topic, ...rest} = props;
  const helpTopics = React.useContext(HelpContext);
  const topicData = helpTopics[topic];

  if (!topicData) {
    console.warn(`No help found for topic ${topic}.`);
  }

  return (
    <Button
      variant="help"
      data-topic={topic}
      size="sm"
      href={topicData?.URL || config.helpCenterUrl}
      target={WINDOW_TARGET}
      rel="noopener"
      {...rest}
    >
      <I18n t="action.help" />
    </Button>
  );
}

HelpButton.propTypes = {
  /** The help topic associated with this button. */
  topic: PropTypes.string.isRequired,
};
